import script from "./ThirdDrop.vue?vue&type=script&lang=ts&setup=true"
export * from "./ThirdDrop.vue?vue&type=script&lang=ts&setup=true"

import "./ThirdDrop.vue?vue&type=style&index=0&id=6b390034&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b390034"]])

export default __exports__